if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;
      else node = node.parentElement;
    }
    return null;
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}

if (!window.scrollTo) {
  window.scrollTo = function (options) {
    if (typeof options === "number") {
      // Legacy two-argument support
      arguments[0] = { top: arguments[0], left: arguments[1] || 0 };
    }

    if (options.behavior === "smooth") {
      // Fallback for browsers without smooth scrolling
      var startX = window.pageXOffset;
      var startY = window.pageYOffset;
      var targetX = options.left || 0;
      var targetY = options.top || 0;

      var startTime = performance.now();
      var duration = 300; // Default smooth scroll duration

      function scroll() {
        var time = performance.now();
        var elapsed = time - startTime;
        var progress = Math.min(elapsed / duration, 1);

        window.scrollTo(
          startX + (targetX - startX) * progress,
          startY + (targetY - startY) * progress,
        );

        if (progress < 1) {
          requestAnimationFrame(scroll);
        }
      }

      requestAnimationFrame(scroll);
    } else {
      // Default scroll behavior
      window.scrollTo(options.left || 0, options.top || 0);
    }
  };
}

if (!global.URLSearchParams) {
  function URLSearchParams(init) {
    this._params = {};

    if (!init) {
      return this;
    }

    if (typeof init === "string") {
      init = init.replace(/^[?#]/, "");

      const pairs = init.split("&");
      for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split("=");
        const key = decodeURIComponent(pair[0] || "");
        const value = decodeURIComponent(pair[1] || "");

        if (this._params[key] === undefined) {
          this._params[key] = value;
        } else if (Array.isArray(this._params[key])) {
          this._params[key].push(value);
        } else {
          this._params[key] = [this._params[key], value];
        }
      }
    } else if (typeof init === "object") {
      for (let key in init) {
        if (init.hasOwnProperty(key)) {
          this._params[key] = init[key];
        }
      }
    }
  }

  URLSearchParams.prototype = {
    get: function (name) {
      const values = this._params[name];
      return Array.isArray(values) ? values[0] : values;
    },

    getAll: function (name) {
      const values = this._params[name];
      return Array.isArray(values) ? values : values ? [values] : [];
    },

    set: function (name, value) {
      this._params[name] = value;
    },

    append: function (name, value) {
      if (this._params[name] === undefined) {
        this._params[name] = value;
      } else if (Array.isArray(this._params[name])) {
        this._params[name].push(value);
      } else {
        this._params[name] = [this._params[name], value];
      }
    },

    delete: function (name) {
      delete this._params[name];
    },

    has: function (name) {
      return name in this._params;
    },

    toString: function () {
      const parts = [];
      for (let key in this._params) {
        const values = this.getAll(key);
        for (let i = 0; i < values.length; i++) {
          parts.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(values[i]),
          );
        }
      }
      return parts.join("&");
    },
  };

  global.URLSearchParams = URLSearchParams;
}

if (!Object.values) {
  Object.values = function (obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  };
}



// WEBPACK FOOTER //
// ./src/polyfills.js